import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withTheme from '../theme/withTheme';
import { CloseIcon } from '../Icons';
import { StickyContainer, NPSContainer, Title, CloseButton, RatingContainer, RatingMiddleContainer, RatingLabel, ReponsiveRatingLabel, RatingButton, ReasonContainer, ReasonTextArea, SubmitButton, FeedbackContainer, FeedbackTitle, FeedbackText } from './styles';
var NPSWidget = function NPSWidget(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    theme = _ref.theme,
    title = _ref.title,
    placeholder = _ref.placeholder;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    reason = _useState4[0],
    setReason = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    submitted = _useState6[0],
    setSubmitted = _useState6[1];
  var _theme$NPSWidget$clos = theme.NPSWidget.closeButton,
    iconColor = _theme$NPSWidget$clos.iconColor,
    iconSize = _theme$NPSWidget$clos.iconSize;
  var renderButtons = function renderButtons() {
    var content = [];
    var _loop = function _loop(i) {
      content.push( /*#__PURE__*/React.createElement(RatingButton, {
        key: i,
        selected: i === rating,
        onClick: function onClick() {
          return setRating(i);
        },
        theme: theme
      }, i));
    };
    for (var i = 1; i <= 10; i += 1) {
      _loop(i);
    }
    return content;
  };
  var handleSubmit = function handleSubmit() {
    if (!rating) return;
    setSubmitted(true);
    if (onSubmit) {
      onSubmit({
        rating: rating,
        reason: reason
      });
    }
  };
  if (isOpen) {
    return /*#__PURE__*/React.createElement(StickyContainer, {
      theme: theme,
      open: isOpen
    }, /*#__PURE__*/React.createElement(CloseButton, {
      onClick: function onClick() {
        return onClose();
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      iconColor: iconColor,
      width: iconSize,
      height: iconSize
    })), submitted ? /*#__PURE__*/React.createElement(FeedbackContainer, {
      theme: theme
    }, /*#__PURE__*/React.createElement(FeedbackTitle, {
      theme: theme
    }, "Obrigado!"), /*#__PURE__*/React.createElement(FeedbackText, {
      theme: theme
    }, "Agradecemos a sua participa\xE7\xE3o.")) : /*#__PURE__*/React.createElement(NPSContainer, {
      theme: theme,
      hasRating: !!rating
    }, /*#__PURE__*/React.createElement(Title, {
      theme: theme
    }, title), /*#__PURE__*/React.createElement(RatingContainer, {
      theme: theme
    }, /*#__PURE__*/React.createElement(RatingLabel, {
      theme: theme
    }, "Improv\xE1vel"), /*#__PURE__*/React.createElement(RatingMiddleContainer, null, renderButtons(), /*#__PURE__*/React.createElement(ReponsiveRatingLabel, {
      theme: theme
    }, "Sendo 1 para \u201DImprov\xE1vel\u201D e 10 \u201DMuito prov\xE1vel\u201D"), /*#__PURE__*/React.createElement(ReasonContainer, {
      theme: theme,
      open: !!rating
    }, /*#__PURE__*/React.createElement(ReasonTextArea, {
      value: reason,
      onChange: function onChange(e) {
        return setReason(e.target.value);
      },
      placeholder: placeholder,
      theme: theme,
      variant: "default",
      hasLabel: false
    }), /*#__PURE__*/React.createElement(SubmitButton, {
      variant: "primary",
      size: "small",
      theme: theme,
      onClick: function onClick() {
        return handleSubmit();
      }
    }, "Enviar"))), /*#__PURE__*/React.createElement(RatingLabel, {
      theme: theme
    }, "Muito prov\xE1vel"))));
  }
  return null;
};
export default withTheme(NPSWidget);
process.env.NODE_ENV !== "production" ? NPSWidget.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string
} : void 0;
NPSWidget.defaultProps = {
  title: 'Qual a probabilidade de você recomendar a Junto Seguros a um amigo ou parceiro?',
  placeholder: 'Conta para gente o que motivou essa nota'
};